import { LocalizedStringModel } from '../../../api/journodex/model/localized-string.model';
import { GeoEntityModel } from '../../../api/journodex/model/journodex-geography-entity-api.model';
import { LanguageTagEnum } from '../../../Core/Localization/enums/language-tag.enum';

export class JournodexGeographicEntityModel {

    static defaultLocale: string = LanguageTagEnum.en_US;

    id: number;
    name: string;
    names: LocalizedStringModel[];
    currentLocale: string = JournodexGeographicEntityModel.defaultLocale;

    /**
     * Class constructor
     */
    constructor(id: number, names: LocalizedStringModel[], locale?: string) {
        this.id = id;
        this.currentLocale = locale || this.currentLocale;
        this.name = this.getValueForGivenLocale(names, this.currentLocale);
        this.names = names;
    }

    /**
     * Determine the localized string name to store for an object instance
     *
     * @param names
     * @param locale
     */
    private getValueForGivenLocale(names: LocalizedStringModel[], locale: string): string {
        let value: string = '';
        let defaultValue: string = '';
        for (let i = 0; i < names.length; i++) {
            if (names[i].locale === locale) {
                value = names[i].value;
                break;
            }

            if (names[i].locale === JournodexGeographicEntityModel.defaultLocale) {
                defaultValue = names[i].value;
            }
        }

        return value !== '' ? value : defaultValue;
    }
    /**
     * Converts JournodexGeographicEntity to GeoEntityModel given current locale
     *
     * @returns GeoEntityModel
     */
    public toApi(): GeoEntityModel {
        return  {
            id: this.id,
            names: this.names
        };
    }
}
